import FontBody1 from '../../fonts/font-body1/font-body1';
import FontHeading4 from '../../fonts/font-heading4/font-heading4';
import { FONT_COLOR, FONT_VARIANT } from '../../fonts/font-props';
import './grid-line-layout.scss';

interface Props {
    title?: string;
    subtitle?: string;
    children: React.ReactNode;
}

const GridLineLayout: React.FC<Props> = ({ title, subtitle, children }) => {
    return (
        <div className="grid-line-layout">
            {(title || subtitle) &&
                <div className="grid-title">
                    {title && <FontHeading4 color={FONT_COLOR.PRIMARY3} variant={FONT_VARIANT.BOLD}>{title}</FontHeading4>}
                    {subtitle && <FontBody1 color={FONT_COLOR.NEUTRAL3}>{subtitle}</FontBody1>}
                </div>
            }
            {children}
        </div>
    )
}

export default GridLineLayout;
